/*
SPDX-FileCopyrightText: 2023 Marlon W (Mawoka)

SPDX-License-Identifier: MPL-2.0
 */
export const navbarVisible = $state({ visible: true });
